import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

class Coop extends React.PureComponent {
    /**
     * 渲染网页布局
     */
    createMarkup = () => {
        return { __html: this.props.content };
    };
    render() {
        /**
         * 组件分发数据
         */
        const { content } = this.props;

        return <div className={styles.coopArea} dangerouslySetInnerHTML={this.createMarkup()} />;
    }
}

/**
 * 定义组件属性类型
 * 类型以及是否需要
 * */
Coop.propTypes = { content: PropTypes.string };

/**
 * 定义组件默认属性
 * */
Coop.defaultProps = {};

export default Coop;
